import Invitation from './invitation'
import { useMetadata } from 'hooks/useMetadata'; // Import the hook

export default function PageInvitations() {
  useMetadata({
    page: 'invitation'
  });

  return (
    <Invitation />
  )
}
